import * as ActionTypes from '../actions/actionTypes';

const defaultState = {
  currentItemId: null,
  currentItemType: null,
  focusedPanel: null,
  loadingScenes: [],
};

const editor = (state = defaultState, action) => {
  switch (action.type) {
    case ActionTypes.EDITOR_SET_LOADING_SCENE: {
      const { loadingScenes } = state;
      const { sceneId } = action;
      const tmp = [...loadingScenes];
      if (sceneId) {
        tmp.push(sceneId);
      }
      return { ...state, loadingScenes: tmp };
    }
    case ActionTypes.EDITOR_SET_SCENE_LOADED: {
      const { loadingScenes } = state;
      const { sceneId } = action;
      const tmp = loadingScenes.filter(id => sceneId !== id);
      return { ...state, loadingScenes: tmp };
    }
    case ActionTypes.EDITOR_FOCUS_PANEL: {
      return { ...state, focusedPanel: action.panel };
    }
    default:
      return state;
  }
};

export default editor;



// WEBPACK FOOTER //
// ./src/redux/reducers/editor.js